/* eslint-disable class-methods-use-this */
import AnalyticsEvent from './AnalyticsEvent';
import { IAnalyticsService, TrackEventOptions } from './AnalyticsService';

const isDebugEnabled = (): boolean => localStorage.getItem('ANALYTICS_DEBUG') === 'true';

class AnalyticsServiceDevImpl implements IAnalyticsService {
  trackEvent(event: AnalyticsEvent, properties?: Record<string, unknown>, options?: TrackEventOptions): void {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.log('[Analytics] trackEvent', { event, properties, options });
  }

  trackPageView(page: string): void {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.log('[Analytics] trackPageView', { page });
  }

  identifyUser(params: { id: number; email: string; name: string; companyId?: number }): void {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.log('[Analytics] identifyUser', params);
  }

  setCompanyId(companyId: number): void {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.log('[Analytics] setCompanyId', { companyId });
  }
}

export default AnalyticsServiceDevImpl;
